import { type ThemeJSON } from "@/lib/theme"

export { amberTheme } from "./amber"
export { defaultTheme } from "./default"
export { techTheme } from "./tech"

import { amberTheme } from "./amber"
import { defaultTheme } from "./default"
import { techTheme } from "./tech"

export const themes: Record<string, ThemeJSON> = {
  default: defaultTheme,
  amber: amberTheme,
  tech: techTheme
}
